import React from 'react'
import styled from 'styled-components'
import InputMask from 'react-input-mask'
import { pxToRem, color } from '../../utils'

const Wrapper = styled.div`
  display: ${props => props.display};
  box-sizing: border-box;
  border-bottom: 1px solid #d8d8d8;
  position: relative;
  font-family: 'Open Sans', sans-serif;
  padding-top: ${pxToRem('16px')};
  width: ${props => props.width};
  margin: ${props => props.margin};
  label {
    position: absolute;
    bottom: ${pxToRem('8px')};
    font-size: ${pxToRem('14px')};
    color: #93a2ac;
    transition: 0.2s;

    ${({ value }) =>
      !!value &&
      `
      color: ${color.primary};
      -ms-transform: translateY(-100%) translateY(${pxToRem('-8px')});
      transform: translateY(calc(-100% + ${pxToRem('-8px')}));
      font-size: ${pxToRem('12px')};
    `};
  }
  .bar {
    width: 0;
    margin: auto;
    transition: 0.2s;
    background: #eee;
    height: 2px;
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    opacity: 0;
  }
  input {
    width: 100%;
    height: 100%;
    padding-bottom: ${pxToRem('8px')};
    display: block;
    box-sizing: border-box;
    outline: none;
    font-size: ${pxToRem('14px')};
    border: none;
    color: #333;
    background: transparent;
    position: relative;
    min-width: ${props => `calc(${props.label.length} * ${pxToRem('8px')})`};
    &:focus {
      & ~ label {
        color: ${color.primary};
        transform: translateY(calc(-100% + ${pxToRem('-8px')}));
        font-size: ${pxToRem('12px')};
      }
      & ~ .bar {
        width: 100%;
        opacity: 1;
        background: ${color.primary};
      }
    }
  }
`

class Input extends React.Component {
  constructor(props) {
    super(props)
    this.inputRef = React.createRef()
  }

  componentDidMount() {
    const { autoFocus } = this.props

    if (autoFocus && this.inputRef.current) {
      this.inputRef.current.focus()
    }
  }

  render() {
    const { label = '', 
            value, 
            type = 'text', 
            display = 'block', 
            width = '100%', 
            margin = '0px', 
            ...rest 
          } = this.props
    
    return (
      <Wrapper value={value} 
               type={type} 
               label={label} 
               display={display} 
               margin={margin} 
               width={width}>
        <InputMask 
            {...rest}
            mask="99/99/9999" 
            value={value}
            type={type}
            aria-label={label}
            ref={c => this.inputRef = c}
        />
        <span className="bar" />
        <label>{label}</label>
      </Wrapper>
    )
  }
}

export default Input



// WEBPACK FOOTER //
// ./src/components/Form/InputMaskDate.js